import { TimeDetails } from 'src/types/services/injection-service.type';
import { v4 } from 'uuid';

export interface DateTimeGroupPropsType {
  onClickOpen: boolean;
  setOnClickOpen: (openState: boolean) => void;
  dateTimeGroupForm: TimeDetails;
  setDateTimeGroupForm: React.Dispatch<React.SetStateAction<TimeDetails>>;
  selectedFormName: string;
  selectedFormId: string;
  entityData: {
    selfId?: string;
    incidentId?: string;
    taskNumberId?: string;
    lineOfEffortId?: string;
  };
  setShouldUpdatedateTimeForm?: (openState: boolean) => void;
  shouldUpdatedateTimeForm?: boolean;

  ppm: boolean;
  odc2m?: boolean;
}

export const defaultDateTimeGroupData = {
  dateTimeGroup: undefined,
  referenceId: undefined,
  referenceIdType: undefined,
  timeDetails: [
    {
      formId: v4(),
      quantity: undefined,
      timeType: undefined,
    },
  ],
  type: undefined,
};
